import createExploreInfiniteTable from './ExploreInfiniteTable';
import { queryFnInfiniteScroll } from 'utils/hooks/useTikTokData';
import useTikTokWeeks from 'utils/hooks/useTikTokWeeks';

const ExploreDataSourceTableInfiniteScroll = createExploreInfiniteTable({
    queryName: 'TikTokData',
    queryFn: queryFnInfiniteScroll,
    usePeriod: useTikTokWeeks,
    sendPeriod: true,
    deepLink: true,
    hashtagDrawerByName: true,
    revealSortedColumn: true,
    priceSegmentation: true,
    clusterFilterKey: 'tikTokCluster',
    clusterPrefix: 'tiktok ',
    healthStatKeys: {
        'average weekly views': 'hs_average_weekly_views',
        'paid views': 'hs_paid_views',
        posts: 'hs_posts',
        'TikTok shop': 'hs_tiktok_shop',
        engagement: 'hs_engagement',
    },
});

export default ExploreDataSourceTableInfiniteScroll;
